export default __webpack_public_path__ + "static/media/slide-6.ceb69b67.gif";